import React from "react";
import { Button, Card, Form, Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import RangeCredit from "components/Game/Addons";
import storage from "utils/Storage";
import { gameCoin } from "actions/gameCoin";
import { setWallet } from "actions/gameWallet";
import { isMobile, Event, wait, isValidNumber, forceSatoshiFormat, __, sendNotfication, playAudio } from 'utils/Helper';
import C from 'utils/Constant';
import "./bet.css";
import { IoAlertCircleOutline } from "react-icons/io5";
class Bet extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: this.props.engine,
      bet: "manual",
      buttonText: "Bet",
      started: false,
      isLogged: storage.getKey("logged") !== null ? true : false,
      amount: forceSatoshiFormat(
        storage.getKey("lam") ? storage.getKey("lam") : 50.00
      ),
      disabled: false,
      payout: "101",
      type: "low",
      betNumber: 10,
      firstBetNumber: 10,
      onWin: 0,
      onLost: 0,
      stopOnWin: 0,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentWillUnmount() {
    let { engine, started } = this.state;
    engine.init = false;
    this._isMounted = false;

    try {
      if (started) {
        document.getElementById("bet").click();
      }
    } catch (e) {}
  }

  componentDidMount() {
    let { engine } = this.state;
    this._isMounted = true;
    this.props.gameCoin();
    engine.on(C.BUSTED_HIGHLOW, (data) => this.busted(data));
    engine.on(C.ERROR_HIGHLOW, (data) => this.error(data));
    engine.on("stop_high_low", () => this.stopAuto());
    engine.on("stop_playing", () => this.stopManual());

    if (isMobile()) {
      this.setState({ mt: "mt-2" });
    }
    this.setState({ amount: 0 });
  }

  stopManual() {
    this.setState({ started: false, buttonText: "Bet", disabled: false });
  }

  stopAuto() {
    if (this._isMounted) {
      this.setState({
        started: false,
        buttonText: "Start Auto Mode",
        disabled: false,
      });
    }
  }

  error(data) {
    if (this._isMounted) {
      sendNotfication(data.message, "info", "top-center");

      if (data.code === "credit") this.props.setWallet(true, data.uid);

      this.setState({ disabled: false });

      if (this.state.started) {
        this.setState({ started: false, buttonText: "Start Auto Mode" });
      }
    }
  }

  busted(data) {
    if (this._isMounted) {
      let { engine, bet, started } = this.state;

      let isWin = false;

      if (parseFloat(data.profit) !== 0) {
        isWin = true;
      }

      if (bet === "auto") {
        if (started) {
          wait(1100).then(() => {
            engine.isWin = isWin;
            engine.roundProfit =
              __.toNumber(data.profit) + __.toNumber(engine.roundProfit);
            this.placeAutoBet();
          });
        }
      }

      wait(1000).then(() => {
        this.setState({ disabled: false });
      });

      wait(500).then(() => {
        if (isWin) {
          playAudio("win.mp3");
        } else {
          // playAudio('lost.mp3');
        }
      });
    }
  }

  setBet(e) {
    if (this._isMounted) {
      e.preventDefault();

      let self = this;

      let { isLogged, amount, bet, started } = this.state;

      // Check User
      if (!isLogged) {
        return Event.emit("showAuthModal", true);
      }

      this.setState({ disabled: true });

      if (parseFloat(amount) <= 0) {
        this.setState({ amount: forceSatoshiFormat(50.00) });
      } else {
        amount = Math.min(
          parseFloat(storage.getKey("credit")),
          parseFloat(amount)
        );
        this.setState({ amount: forceSatoshiFormat(amount) });
      }

      if (bet === "auto") {
        if (started) {
          this.setState({
            started: false,
            buttonText: "Start Auto Mode",
            disabled: false,
          });
          return false;
        } else {
          this.setState({ started: true, buttonText: "Stop Auto Mode" });
          this.placeAutoBet();
        }
      } else {
        this.placeBet();
      }
    }
  }

  placeAutoBet() {
    if (this._isMounted) {
      let {
        engine,
        amount,
        payout,
        type,
        betNumber,
        firstBetNumber,
        onWin,
        onLost,
        stopOnWin,
      } = this.state;
      wait(500).then(() => {
        engine.init = true;
        engine.amount = amount;
        engine.type = type;
        engine.payout = payout;
        engine.coin = this.props.coin;
        engine.betNumber = firstBetNumber;
        engine.stopOnWin = parseInt(stopOnWin);
        engine.onWin = parseInt(onWin);
        engine.onLost = parseInt(onLost);
        engine.autoStart();
        this.setState({ betNumber: betNumber - 1 });
      });
    }
  }

  placeBet() {
    if (this._isMounted) {
      let { amount, type, payout, engine } = this.state;

      wait(100).then(() => {
        engine.game = "high_low";
        engine.init = true;
        engine.amount = amount;
        engine.payout = payout;
        engine.type = type;
        engine.coin = this.props.coin;
        engine.start();
      });
    }
  }

  handleChangeType = (value) => {
    this.setState({ type: value });
  };

  handleInputChange(event) {
    let target = event.target;
    let value = target.value;

    if (target.name === "amount" || target.name === "stopOnWin") {
      this.setState({ amount: value });
      if (!isValidNumber(value)) return;
    }

    if (target.name === "amount") {
      storage.setKey("lam", value);
    } else {
      this.setState({ [target.name]: value });
    }
  }

  betMode = (type) => {
    let text;

    if (type === "auto") {
      text = "Start Auto Mode";
    } else {
      text = "Bet";
    }
    this.setState({ bet: type, buttonText: text });
  };

  setAmount = (val) => {
    var am = forceSatoshiFormat(val);
    this.setState({ amount: am });
    storage.setKey("lam", am);
  };

  setNumber = (e, num) => {
    e.preventDefault();
    this.setState({ betNumber: num });
    this.setState({ firstBetNumber: num });
  };

  render() {
    let { disabled, amount, bet, type, started, mt } = this.state;
    return (
      <>
        <div
          style={{
            marginTop: "10px",
            paddingRight: "12px",
            paddingLeft: "12px",
          }}
          className="btn-group btn-group-toggle mb-1 ml-1 limbo-auto-manual-button"
          data-toggle="buttons"
        >
          <label
            className={
              "" + bet === "manual"
                ? "btn bg-cs2 btn-xs active limbo-manual-button-active"
                : "btn bg-cs2 btn-xs limbo-manual-button"
            }
          >
            <input
              disabled={disabled}
              onClick={(e) => this.betMode("manual")}
              type="radio"
            />{" "}
            Manual
          </label>
          <label
            className={
              "" + bet === "auto"
                ? "btn bg-cs2 btn-xs active limbo-auto-button-active"
                : "btn bg-cs2 btn-xs limbo-auto-button"
            }
          >
            <input
              disabled={disabled}
              onClick={(e) => this.betMode("auto")}
              type="radio"
            />{" "}
            Auto
          </label>
        </div>
        <Form onSubmit={(e) => this.setBet(e)}>
          <div
            style={{
              padding: "2px",
              display: "flex",
              justifyContent: "center",
            }}
            className={"col-md-12 text-center btn-group-toggle my-3 " + mt}
            data-toggle="buttons"
          >
            <label
              className={
                "" + type === "low"
                  ? "btn bg-cs2 btn-xs hslb  active col-md-4 highlow-active-button"
                  : "btn bg-cs2 btn-xs hslb col-md-4 highlow-button"
              }
            >
              <input
                disabled={disabled}
                onClick={(e) => this.handleChangeType("low")}
                type="radio"
              />{" "}
              <i className="mdi mdi-arrow-down-bold font-19 align-middle" /> 500
            </label>
            <label
              className={
                "" + type === "equal"
                  ? "btn bg-cs2 btn-xs hsmb  active col-md-2 highlow-active-button"
                  : "btn bg-cs2 btn-xs hsmb col-md-2 highlow-button"
              }
            >
              <input
                disabled={disabled}
                onClick={(e) => this.handleChangeType("equal")}
                type="radio"
              />{" "}
              <i className="mdi mdi mdi-equal font-19 align-middle" />
            </label>
            <label
              className={
                "" + type === "high"
                  ? "btn bg-cs2 btn-xs hsrb  active col-md-4 highlow-active-button"
                  : "btn bg-cs2 btn-xs hsrb col-md-4 highlow-button"
              }
            >
              <input
                disabled={disabled}
                onClick={(e) => this.handleChangeType("high")}
                type="radio"
              />{" "}
              <i className="mdi mdi-arrow-up-bold font-19 align-middle" /> 500
            </label>
          </div>
          <Row className={"mt-1"}>
            <Col md={12}>
              <div className="crash-bet-input-label">
                <div className="crash-bet-input-label-left">
                  <div>Amount</div>
                  <div style={{ paddingLeft: "5px" }}>
                    <IoAlertCircleOutline color="#56CF17" size={"17px"} />
                  </div>
                </div>
               
              </div>
              <div className="form-group mb-1">
                <div className="input-group">
                  <div className="input-group-append">
                    <span className="input-group-text crash-game-bet-game">
                      <img
                        src={"/assets/images/" + this.props.coin + ".png"}
                        className={"mini-coin-7"}
                        alt=""
                      />
                      {/* BET */}
                    </span>
                  </div>
                  <input
                    style={{ background: "#222328", paddingLeft: "0px" }}
                    disabled={disabled}
                    type="text"
                    id="amount"
                    name="amount"
                    placeholder=".."
                    value={amount}
                    autoComplete={"off"}
                    onKeyUp={this.handleInputChange}
                    onChange={this.handleInputChange}
                    className="form-control text-left"
                    required={true}
                  />
                  <div className="input-group-append">
                    <RangeCredit set={this.setAmount} />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={12}>
              <div className="crash-bet-input-label">
                <div className="crash-bet-input-label-left">
                  <div> WIN AMOUNT</div>
                  {/* <div style={{paddingLeft:"5px"}}><IoAlertCircleOutline color="#56CF17" size={"17px"} /></div> */}
                </div>
                <div className="crash-bet-input-label-right"></div>
              </div>
              <div className={"form-group mb-1 bet-input"}>
                <div className="input-group">
                  <div className="input-group-append">
                    <span className="input-group-text crash-game-bet-game">
                      <img
                        src={"/assets/images/" + this.props.coin + ".png"}
                        className={"mini-coin-7"}
                        alt=""
                      />
                      {/* WIN AMOUNT */}
                    </span>
                  </div>
                  <input
                    style={{
                      background: "#222328",
                      paddingLeft: "0px",
                      borderTopRightRadius: "20px",
                      borderBottomRightRadius: "20px",
                    }}
                    type="text"
                    disabled={true}
                    className="form-control"
                    value={this.state.amount}
                    // value={(forceSatoshiFormat(3 ? (this.state.amount * 3 - (this.state.amount / 2)) / 4 : 0.00000004))}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px", marginBottom: "10px" }}>
            <Col md={12} sm={12} className="m-auto">
              {bet === "manual" && (
                <div className={"form-group rev mt-2 mb-0"}>
                  <Button
                    style={{
                      //                     color: "rgb(245, 246, 247)",
                      boxShadow: "rgba(29, 34, 37, 0.1) 0px 4px 8px 0px",
                      backgroundColor: "rgb(67, 179, 9)",
                      backgroundImage:
                        "conic-gradient(from 1turn, rgb(67, 179, 9), rgb(93, 219, 28))",
                      borderRadius: "2rem",
                    }}
                    variant={"btn btn-block btn-bet btn-xl mb-2"}
                    id={"bet"}
                    disabled={disabled}
                    type="submit"
                  >
                    {this.state.buttonText}
                  </Button>
                </div>
              )}
            </Col>
          </Row>
          {bet === "auto" && (
            <>
              <Row>
                <Col md={12}>
                  <div className="crash-bet-input-label">
                    <div className="crash-bet-input-label-left">
                      <div>Number of Bets</div>
                    </div>
                  </div>
                  <div className={"form-group mb-1 bet-input"}>
                    <div className="input-group">
                      <div className="input-group-append">
                        {/* <span style={{background:"#222328", paddingLeft:"0px",borderTopLeftRadius:"20px",borderBottomLeftRadius:"20px"}} className="input-group-text">
                                                    Bets Num
                                                </span> */}
                      </div>
                      <input
                        style={{
                          background: "#222328",
                          fontWeight: "600",
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                          paddingLeft: "25px",
                          fontSize: "17px",
                        }}
                        type="number"
                        disabled={disabled}
                        className="form-control"
                        required={true}
                        value={this.state.betNumber}
                        onChange={(e) => this.setNumber(e, e.target.value)}
                      />
                      <div className="input-group-append">
                        <button
                          onClick={(e) => this.setNumber(e, 10)}
                          className={
                            "btn btn-s-4 btn-xs crash-game-manual-buttons-2"
                          }
                        >
                          10
                        </button>
                        <button
                          onClick={(e) => this.setNumber(e, 50)}
                          className={
                            "btn btn-s-4 btn-xs crash-game-manual-buttons-2"
                          }
                        >
                          50
                        </button>
                        <button
                          style={{
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "#31343C",
                            color: "#99A4B0",
                            fontSize: "17px",
                          }}
                          onClick={(e) => this.setNumber(e, 100)}
                          className={"btn btn-s-4 btn-xs "}
                        >
                          100
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="crash-bet-input-label">
                    <div className="crash-bet-input-label-left">
                      <div>Increase Amount On Win %</div>
                    </div>
                  </div>
                  <div className={"form-group mb-1 bet-input"}>
                    <div className="input-group">
                      <div className="input-group-append">
                        {/* <span className="input-group-text">
                                                    Increase Amount On Win
                                                </span> */}
                      </div>
                      <input
                        style={{
                          background: "#222328",
                          fontWeight: "600",
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                          paddingLeft: "25px",
                          fontSize: "17px",
                        }}
                        disabled={disabled}
                        type="number"
                        className="form-control"
                        name="onWin"
                        min="0"
                        max="100"
                        autoComplete={"off"}
                        value={this.state.onWin}
                        onChange={(e) =>
                          this.setState({ onWin: e.target.value })
                        }
                      />
                      <div className="input-group-append">
                        <span
                          style={{
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                          }}
                          className="input-group-text"
                        >
                          <i
                            className="mdi mdi-close"
                            style={{
                              fontSize: "16px",
                              color: "#43B309",
                              fontWeight: "900",
                            }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="crash-bet-input-label">
                    <div className="crash-bet-input-label-left">
                      <div>Stop on win</div>
                    </div>
                    <div
                      className="payout-chance-limbo"
                      style={{ paddingLeft: "3px", fontSize: "18px" }}
                    >
                      <div>0</div>
                      <span>USD</span>
                    </div>
                  </div>
                  <div className={"form-group mb-1 bet-input"}>
                    <div className="input-group">
                      <div className="input-group-append">
                        {/* <span className="input-group-text">
                                                    Stop On Win
                                                </span> */}
                      </div>
                      <div className="input-group-append">
                        <div className="limbo-auto-coin">
                          <img
                            src={"/assets/images/" + this.props.coin + ".png"}
                            className={"mini-coin-2 mr-1"}
                            alt=""
                          />
                          {/* {this.props.coin} */}
                        </div>
                      </div>
                      <input
                        style={{
                          background: "#222328",
                          fontWeight: "600",
                          fontSize: "17px",
                          borderBottomRightRadius: "20px",
                          borderTopRightRadius: "20px",
                        }}
                        disabled={disabled}
                        type="text"
                        placeholder=".."
                        className="form-control"
                        name="stopOnWin"
                        value={this.state.stopOnWin}
                        autoComplete={"off"}
                        onChange={this.handleInputChange}
                      />
                    </div>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="crash-bet-input-label">
                    <div className="crash-bet-input-label-left">
                      <div>Increase Amount On Lost %</div>
                    </div>
                  </div>
                  <div className={"form-group mb-1 bet-input"}>
                    <div className="input-group">
                      <div className="input-group-append">
                        {/* <span className="input-group-text">
                                                    Increase Amount On Lost
                                                </span> */}
                      </div>
                      <input
                        style={{
                          background: "#222328",
                          fontWeight: "600",
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                          paddingLeft: "25px",
                          fontSize: "17px",
                        }}
                        disabled={disabled}
                        type="number"
                        className="form-control"
                        name="onLost"
                        min="0"
                        max="100"
                        autoComplete={"off"}
                        value={this.state.onLost}
                        onChange={(e) =>
                          this.setState({ onLost: e.target.value })
                        }
                      />
                      <div className="input-group-append">
                        <span
                          style={{
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                          }}
                          className="input-group-text"
                        >
                          <i
                            className="mdi mdi-close"
                            style={{
                              fontSize: "16px",
                              color: "#43B309",
                              fontWeight: "900",
                            }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row
                style={{
                  paddingLeft: "12px",
                  paddingRight: "12px",
                  marginTop: "15px",
                }}
              >
                <Col md={12} className={"m-auto"}>
                  <div className={"form-group mt-0 mb-0 rev"}>
                    <Button
                      className="start-auto-bet-mode-button"
                      style={{
                        // border: "2px solid red",
                        color: "#fff",
                        boxShadow:
                          "0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px rgb(29, 202, 106) inset",

                        // backgroundColor: "rgb(67, 179, 9)",
                        backgroundImage:
                          "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
                        borderRadius: "10px",
                      }}
                      variant={"btn btn-md btn-block my-2 btn-bet"}
                      type="submit"
                    >
                      {this.state.buttonText}
                      {started && (
                        <>
                          <div
                            className={"ml-2 spinner-border spinner-border-sm"}
                          />
                        </>
                      )}
                    </Button>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </Form>
      </>
    );
  }
}

Bet.propTypes = {
  coin: PropTypes.string,
  credit: PropTypes.string,
};

const mapStateToProps = (state) => ({
  coin: state.items.coin,
  credit: state.items.credit,
});

export default connect(mapStateToProps, { gameCoin, setWallet })(Bet);
